var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{ref:"input",staticClass:"chat-input-message",attrs:{"rows":"1","placeholder":"Введите текст сообщения","autocomplete":"off"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.onUpdate($event.target.value)},"keydown":_vm.onKeydown}})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }